import React, { useEffect, useRef, useState } from "react";
import logo1 from "../assets/images/Home/White Logo.png";
import logo2 from "../assets/images/Home/LO1-removebg-preview.png";
import { FaXTwitter, FaInstagram } from "react-icons/fa6";
import { TiSocialFacebook } from "react-icons/ti";
import { GrYoutube } from "react-icons/gr";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useAdmin } from "../hook/useAdmin";

const Footer = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);

    const [showRefundModal, setShowRefundModal] = useState(false);
    const [showTermsModal, setShowTermsModal] = useState(false);
    const { trackVisitor, getVisitorCounts } = useAdmin();
    const [todayCount, setTodayCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [latestMonth, setLatestMonth] = useState("");
    const [latestReviewDate, setLatestReviewDate] = useState("");

 const hasInitialized = useRef(false);

useEffect(() => {
    if (hasInitialized.current) return;

    hasInitialized.current = true;

    const init = async () => {
        try {
             // Track visitor once
            await trackVisitor();

            // Fetch counts
            const response = await getVisitorCounts();
            setTodayCount(response?.data?.todayCount);
            setTotalCount(response?.data?.totalCount);
            setLatestMonth(response?.data?.latestMonth);
            setLatestReviewDate(response?.data?.latestReviewDate);
        } catch (error) {
            console.error("Error fetching visitor counts:", error);
        }
    };
    init();
}, []);

    const marathiMonths = [
        "जानेवारी",
        "फेब्रुवारी",
        "मार्च",
        "एप्रिल",
        "मे",
        "जून",
        "जुलै",
        "ऑगस्ट",
        "सप्टेंबर",
        "ऑक्टोबर",
        "नोव्हेंबर",
        "डिसेंबर",
    ];

    const formatMarathiMonth = (dateStr) => {
        if (!dateStr) return "";

        const [, month, year] = dateStr.split("/");
        const marathiMonth = marathiMonths[Number(month) - 1];
        const marathiYear = convertToMarathiNumber(year);

        return `${marathiMonth} ${marathiYear}`;
    };

    const convertToMarathiNumber = (value) => {
        if (value === null || value === undefined) return "";

        const marathiDigits = {
            0: "०",
            1: "१",
            2: "२",
            3: "३",
            4: "४",
            5: "५",
            6: "६",
            7: "७",
            8: "८",
            9: "९",
        };

        return value
            .toString()
            .split("")
            .map((char) => (marathiDigits[char] ? marathiDigits[char] : char))
            .join("");
    };




    // Convert numbers
    const displayTodayCount =
        selectedLang === "मराठी"
            ? convertToMarathiNumber(todayCount)
            : todayCount.toString();

    const displayTotalCount =
        selectedLang === "मराठी"
            ? convertToMarathiNumber(totalCount)
            : totalCount.toString();

    const displayLatestMonth =
        selectedLang === "मराठी"
            ? formatMarathiMonth(latestReviewDate)
            : latestMonth;



    const displayLatestReviewDate =
        selectedLang === "मराठी"
            ? convertToMarathiNumber(latestReviewDate)
            : latestReviewDate;





    const todayDigits = displayTodayCount.split("");
    const totalDigits = displayTotalCount.split("");

    const headerLogos = {
        English: {
            logo1: logo1,
        },
        मराठी: {
            logo1: logo2,
        },
    };


    const footerContent = {
        headings: {
            attractions: { id: 1, English: "ATTRACTIONS", मराठी: "आकर्षणे" },
            followUs: { id: 2, English: "Follow us on", मराठी: "आमच्याशी संपर्क साधा" },
            permissions: { id: 3, English: "PERMISSION & LICENSE", मराठी: "परवानग्या व परवाने" },
            app: { id: 4, English: "App", मराठी: "अ‍ॅप" },
            getInTouch: { id: 5, English: "GET IN TOUCH", मराठी: "संपर्क साधा" },
            importantLink: { id: 6, English: "Important Reference Sites", मराठी: " महत्वाची संदर्भ संकेतस्थळे" },
            tenders: { id: 7, English: "TENDERS", मराठी: "निविदा" },
            rti: { id: 8, English: "RTI", मराठी: "माहितीचा अधिकार" },
            careers: { id: 9, English: "CAREER", मराठी: "करिअर" },
            events: { id: 10, English: "EVENTS", मराठी: "कार्यक्रम" },
            visitorsCount: { id: 11, English: "Visitor Count:", मराठी: "पाहुण्यांची संख्या:" },
            dailyVisitors: { id: 12, English: "Daily Visitor Count:", मराठी: "दैनंदिन पाहुण्यांची संख्या:" },
            latestMonth: { id: 12, English: "Current Month:", मराठी: "चालू महिना:" },
            latestReviewDate: { id: 12, English: "Last Review:", मराठी: "शेवटचे पुनरावलोकन:" },
        },
        links: {
            id: 2,
            attractions: [
                { id: "museums", to: "/museums", label: { English: "Museums", मराठी: "संग्रहालये" } },
                { id: "monuments", to: "/monuments", label: { English: "Monuments", मराठी: "स्मारके" } },
            ],
            permissions: [
                { id: "filming", to: "/film-shooting", label: { English: "Filming/Video Shooting", मराठी: "चित्रपट/व्हिडिओ शूटिंग" } },
                { id: "event", to: "/event-permission", label: { English: "Gateway of India Event Permission", मराठी: "गेटवे ऑफ इंडिया कार्यक्रमाची परवानगी" } },
            ],
            getInTouch: [
                { id: "archaeology", href: "/contact#archaeology", label: { English: "Archaeology", मराठी: "पुरातत्त्व" } },
                { id: "museums-contact", href: "/contact#museums-contact", label: { English: "Museums", मराठी: "संग्रहालये" } },
            ],
            importantLink: {
                id: "maharashtra-site",
                href: "https://maharashtra.gov.in",
                label: { English: "maharashtra.gov.in", मराठी: "maharashtra.gov.in" },
            },
            tendersSection: [
                { id: "rti", to: "/rti", label: { English: "RTI", मराठी: "माहितीचा अधिकार" } },
                { id: "careers", to: "/careers", label: { English: "CAREER", मराठी: "करिअर" } },
                { id: "events", to: "/events", label: { English: "EVENTS", मराठी: "कार्यक्रम" } },
            ],
            appLink: {
                id: "app-google-play",
                href: "#",
                label: { English: "MahaMuseums (on Google Play)", मराठी: "महाम्युझियम्स (गूगल प्लेवर)" },
            },
        },
    };


    useEffect(() => {
        if (showRefundModal || showTermsModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [showRefundModal, showTermsModal]);

    const handleOpenYouTube = () => {
        window.open("https://www.youtube.com/@maharashtraarchaeology3092", "_blank", "noopener,noreferrer");
    };

    const handleOpenInstagram = () => {
        window.open(" https://www.instagram.com/doam_maharashtra/", "_blank", "noopener,noreferrer");
    };

    const handleOpenTwitter = () => {
        window.open("https://x.com/DoAM_Mumbai", "_blank", "noopener,noreferrer");
    };

    const handleOpenFacebook = () => {
        window.open("https://www.facebook.com/profile.php?id=61572910157014", "_blank", "noopener,noreferrer");
    };



    return (
        <footer className="bg-[#FB9C00] text-white text-xs sm:text-sm px-4 xl:px-16 py-6">

            {/* MAIN MENU GRID */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">

                {/* Permission */}
                <div>
                    <h3 className="font-semibold mb-2">
                        {footerContent.headings.permissions[selectedLang]}
                    </h3>
                    <ul className="list-disc ml-4 space-y-1">
                        {footerContent.links.permissions.map((item) => (
                            <li key={item.id}>
                                <Link to={item.to} className="hover:underline">{item.label[selectedLang]}</Link>
                            </li>
                        ))}                    </ul>
                </div>

                {/* App */}


                {/* Tenders */}
                <div>
                    <h3 className="hover:underline font-semibold mb-1">
                        <Link to="/tenders">{footerContent.headings.tenders[selectedLang]}</Link>
                    </h3>
                    <ul className="space-y-1">
                        {footerContent.links.tendersSection.map((item) => (
                            <li key={item.id}>
                                <Link to={item.to} className="hover:underline font-semibold">{item.label[selectedLang]}</Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Important Links */}
                <div>
                    <h3 className="font-semibold mb-2">
                        {footerContent.headings.importantLink[selectedLang]}
                    </h3>
                    <ul className="list-disc ml-4 space-y-1">
                        <li>
                            <a href={footerContent.links.importantLink.href} target="_blank" rel="noopener noreferrer" className="hover:underline block">
                                {footerContent.links.importantLink.label[selectedLang]}
                            </a>
                        </li>
                        <li>
                            <button type="button" onClick={() => setShowRefundModal(true)} className="hover:underline block text-left no-btn">
                                {selectedLang === "मराठी" ? "परतावा धोरण" : "Refund Policy"}
                            </button>
                        </li>
                        <li>
                            <button type="button" onClick={() => setShowTermsModal(true)} className="hover:underline block text-left no-btn">
                                {selectedLang === "मराठी" ? "नियम व अटी" : "Terms & Conditions"}
                            </button>
                        </li>
                        
                        {/* Refund Policy Modal */}
                        {showRefundModal && (
                            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
                                <div className="overflow-y-auto max-h-[90vh] w-full max-w-4xl mx-4 sm:mx-6 md:mx-auto bg-white rounded-lg shadow-lg flex flex-col">

                                    {/* Modal Header */}
                                    <div className="sticky top-0 flex justify-between items-center px-4 py-3 border-b z-10 bg-white">
                                        <h2 className="text-lg sm:text-2xl font-bold text-gray-800">
                                            {selectedLang === "मराठी" ? "परतावा धोरण" : "Refund Policy"}
                                        </h2>
                                        <button
                                            onClick={() => setShowRefundModal(false)}
                                            className="no-btn text-gray-500 hover:text-gray-700 text-3xl font-bold leading-none focus:outline-none"
                                            aria-label="Close"
                                        >
                                            &times;
                                        </button>
                                    </div>

                                    {/* Modal Body */}
                                    <div className="p-6 space-y-4 text-sm sm:text-base text-gray-800">
                                        <h3 className="font-bold text-lg">Refund Policy for Conducting Events at State Protected Monument Directorate of Archaeology and Museums, Government of Maharashtra.</h3>

                                        <p className="font-semibold no-dark-text">Issued By:</p>
                                        <p className="no-dark-text">Directorate of Archaeology and Museums, <br />
                                            (Ministry of Tourism and Cultural Affairs) Government of Maharashtra</p>

                                        <p className="font-semibold no-dark-text">Effective Date:</p>
                                        <hr />

                                        <h4 className="font-bold">1. Applicability</h4>
                                        <p className="no-dark-text">
                                            This Refund Policy applies to all applicants (Government Departments, NGOs, Private Institutions, Event Management Companies, Foreign Embassies, and Joint Ventures) who have paid fees for conducting approved events at the State Protected Monument, Archaeology and Museums (DoAM), Government of Maharashtra (GOM).
                                        </p>
                                        <hr />
                                        <h4 className="font-bold">2. Refund Conditions</h4>

                                        <h5 className="font-semibold">2.1 Cancellation by Applicant</h5>
                                        <ul className="list-disc ml-6">
                                            <li>
                                                If the applicant <span className="font-semibold">cancels the proposed event at least 12 days prior</span> to the event date, <span className="font-semibold">50% of the booking fee</span> (excluding express charges and/or royalty, if any) will be refunded.
                                            </li>
                                            <li>
                                                <span className="font-semibold">No refund</span> shall be issued for cancellations made within 12 days of the event date.
                                            </li>
                                        </ul>

                                        <h5 className="font-semibold">2.2 Force Majeure or Government Unavailability</h5>
                                        <ul className="list-disc ml-6">
                                            <li>
                                                In case of <span className="font-semibold">natural calamities or unavoidable administrative reasons</span> leading to unavailability of the State Protected Monument’s premises on the booked date:
                                                <ul className="list-disc ml-6 mt-2">
                                                    <li>
                                                        The Directorate will <span className="font-semibold">attempt to provide an alternative date</span>.
                                                    </li>
                                                    <li>
                                                        If the applicant <span className="font-semibold">declines the alternate date</span>, <span className="font-semibold">75% of the booking fee</span> will be refunded.
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>

                                        <h5 className="font-semibold">2.3 Security Deposit Refund</h5>
                                        <ul className="list-disc ml-6">
                                            <li>
                                                The security deposit to be paid as per the General Resolution (GR) No. <br />
                                                <span className="font-mono">_________ 2021 क्रमांक संकीर्ण-189/प्र.क्र.3, dated 07 July 2022 (________)</span> shall be refunded only after:
                                                <ul className="list-disc ml-6 mt-2">
                                                    <li>Satisfactory inspection of the site.</li>
                                                    <li>Confirmation that <span className="font-semibold">no damage has occurred</span> to the monument or its premises.</li>
                                                    <li>Fulfilment of all administrative and regulatory requirements.</li>
                                                </ul>
                                            </li>
                                        </ul>
                                        <ul className="list-disc ml-6">
                                            <li>
                                                Any <span className="font-semibold">damage costs</span> will be <span className="font-semibold">deducted</span> from the security deposit. <br />
                                                <span className="font-mono">_________ 2021 क्रमांक संकीर्ण-189/प्र.क्र.3, dated 07 July 2022 (________)</span> shall be refunded only after:
                                                <ul className="list-disc ml-6 mt-2">
                                                    <li>If the damage cost is less than the security amount, the remaining amount will be refunded to the applicant.</li>
                                                    <li>If the damage costs exceed the deposit, the excess amount will be recovered separately from the applicant.</li>
                                                    <li>he applicant shall be subject to legal action in case of failure of payment of the excess amount.</li>
                                                </ul>
                                            </li>
                                        </ul>

                                        <h5 className="font-semibold">2.4 Timeline for Refund Request</h5>
                                        <ul className="list-disc ml-6">
                                            <li>
                                                Refund of the security deposit or booking amount (where applicable) <span className="font-bold">
                                                    must be
                                                </span>
                                                <br />
                                                <span className="font-bold"> requested within 1 year</span> from the event date.
                                                <ul className="list-disc ml-6 mt-2">
                                                    <li>After this period, <span className="font-bold">no refund claim will be entertained,</span> and the amount will be forfeited to the Government Treasury.</li>
                                                    <li>The matters on which the enquiry is pending, will be exempted from this rule and the refund amount will not be deposited to the government account until the enquiry is complete.</li>
                                                </ul>
                                            </li>
                                        </ul>
                                        <hr />
                                        <h4 className="font-bold">3. Non-Refundable Components</h4>
                                        <ul className="list-disc ml-6">
                                            <li>
                                                <span className="font-semibold">Express Charges</span> (₹1,00,000) levied for late applications (i.e., less than 21 days before the event) are <span className="font-semibold">non-refundable</span>.
                                            </li>
                                            <li>
                                                <span className="font-semibold">Royalty fees</span> (₹1,00,000) for use of State Protected Monument’s images or logo for branding purposes are also <span className="font-semibold">non-refundable</span>.
                                            </li>
                                            <li>
                                                <span className="font-semibold">GST or other applicable taxes</span> paid at the time of booking are <span className="font-semibold">non-refundable</span> unless mandated by law.
                                            </li>
                                        </ul>
                                        <hr />
                                        <h4 className="font-bold">4. Refund Mode and Processing Time</h4>
                                        <ul className="list-disc ml-6">
                                            <li>All refunds will be processed through the <span className="font-semibold">original mode of payment</span> used at the time of booking.</li>
                                            <li>Refunds, once approved, will be processed within <span className="font-semibold">30 working days</span>.</li>
                                            <li>In case of technical delays or verifications by the concerned departments, the processing may take longer, for which the Directorate shall not be held liable.</li>
                                        </ul>
                                        <hr />
                                        <h4 className="font-bold">5. Dispute Resolution</h4>
                                        <ul className="list-disc ml-6">
                                            <li>
                                                All disputes arising out of or in connection with these Terms shall be subject to arbitration by the
                                                <span className="font-semibold">Principal Secretary, Department of Cultural Affairs, Mantralaya Mumbai.</span>If the matter remains unresolved, the same can be referred to the courts in<span className="font-semibold">MUMBAI, Maharashtra</span>.
                                            </li>
                                            <li>
                                                The final authority in case of any conflict or ambiguity in refund matters will be with the<span className="font-semibold">Directorate of Archaeology and Museums, Mumbai</span>.
                                            </li>
                                            <li>
                                                In case of any legal suit/dispute arbitration, it will be jurisdiction of court based in Mumbai.
                                            </li>
                                        </ul>
                                        <hr />
                                        <h4 className="font-bold">6. Contact Information</h4>
                                        <p className="whitespace-pre-line no-dark-text">
                                            <span className="font-semibold">Directorate of Archaeology and Museums</span>{"\n"}
                                            St. George Fort, St. George Hospital Campus, Mumbai - 400001{"\n"}
                                            Email: maharashtraeology@gmail.com{"\n"}
                                            Phone: 022-22623380
                                        </p>
                                        <hr />
                                        <p className="text-xs mt-4 text-gray-600 no-dark-text">
                                            <span className="font-semibold text-black">Note:</span> This refund policy is in line with Government Resolution No. क्रमांक – 2021/संकीर्ण, 189/प्र.क्र.3 dated 07 July 2022 issued by the Ministry of Tourism and Cultural Affairs, Government of Maharashtra.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}


                        {/* Terms & Conditions Modal */}
                        {showTermsModal && (
                            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
                                <div className="overflow-y-auto max-h-[90vh] w-full max-w-4xl mx-4 sm:mx-6 md:mx-auto bg-white rounded-lg shadow-lg flex flex-col">
                                    {/* Modal Header */}
                                    <div className="sticky top-0 flex justify-between items-center px-4 py-3 border-b z-10 bg-white">
                                        <h2 className="text-lg sm:text-2xl font-bold text-gray-800">Terms & Conditions</h2>
                                        <button
                                            onClick={() => setShowTermsModal(false)}
                                            className="no-btn text-gray-500 hover:text-gray-700 text-3xl font-bold leading-none focus:outline-none"
                                            aria-label="Close"
                                        >
                                            &times;
                                        </button>
                                    </div>

                                    {/* Modal Body */}
                                    <div className="p-6 space-y-4 text-sm sm:text-base text-gray-800">
                                        <p className="text-sm text-black mb-4 font-bold no-dark-text">Last updated on 27-08-2025 11:39:19</p>
                                        <p className="no-dark-text">
                                            These Terms and Conditions, along with privacy policy or other terms (“Terms”) constitute a binding agreement by and between <span className="font-medium">DIRECTORATE OF ARCHAEOLOGY AND MUSEUMS MUMBAI</span>, (“Website Owner” or “we” or “us” or “our”) and you (“user” or “you” or “your”) and relate to your use of our website, goods (as applicable) or services (as applicable) (collectively, “Services”).
                                        </p>

                                        <p className="no-dark-text">
                                            By using our website and availing the Services, you agree that you have read and accepted these Terms (including the Privacy Policy). We reserve the right to modify these Terms at any time and without assigning any reason. It is your responsibility to periodically review the Terms to stay informed of updates.
                                        </p>

                                        <p className="no-dark-text">
                                            The use of this website or availing of our Services is subject to the following terms of use:
                                        </p>

                                        <ul className="list-disc ml-6">
                                            <li>To access and use the Services, you agree to provide true, accurate and complete information to us during and after registration, and you shall be responsible for all acts done through the use of your registered account.</li>

                                            <li>Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness, or suitability of the information and materials offered on this site or Services for any specific purpose. You acknowledge that such information and materials may contain inaccuracies or errors, and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.</li>

                                            <li>Your use of our Services or website is solely at your own risk and discretion. You are required to independently assess and ensure that the Services meet your requirements.</li>

                                            <li>The contents of the Website and the Services are proprietary to Us, and you will not have any authority to claim any intellectual property rights, title, or interest in its contents.</li>
                                            <li> You acknowledge that unauthorized use of the Website or the Services may lead to action against you as per these Terms or applicable laws.</li>
                                            <li> You agree to pay us the charges associated with availing the Services.</li>
                                            <li>You agree not to use the website and/ or Services for any purpose that is unlawful, illegal or forbidden by these Terms, or Indian or local laws that might apply to you</li>
                                            <li> You agree and acknowledge that website and the Services may contain links to other third-party websites.  On accessing these links, you will be governed by the terms of use, privacy policy and such other policies of such third-party websites</li>
                                            <li> You understand that upon initiating a transaction for availing the Services you are entering into a legally binding and enforceable contract with the us for the Services.</li>

                                            <li>You shall be entitled to claim a refund of the payment made by you in case we are not able to provide the Service. The timelines for such return and refund will be according to the specific Service you have availed or within the time period provided in our policies (as applicable). In case you do not raise a refund claim within the stipulated time, then this would make you ineligible for a refund.</li>
                                            <li>Notwithstanding anything contained in these Terms, the parties shall not be liable for any failure to perform an obligation under these Terms if performance is prevented or delayed by a force majeure event</li>
                                            <li>These Terms and any dispute or claim relating to it, or its enforceability, shall be governed by and construed in accordance with the laws of India.</li>
                                            <li>All disputes arising out of or in connection with these Terms shall be subject to the arbitration by Principle Secretory, Department of Cultural Affairs, Mumbai. If the matter remains unresolved, the same can be referred to the courts in MUMBAI, Maharashtra.</li>
                                            <li> All concerns or communications relating to these Terms must be communicated to us using the contact information provided on this website.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                        <li>
  <Link to="/sitemap" className="hover:underline">
    {selectedLang === "मराठी" ? "साइटमॅप" : "Sitemap"}
  </Link>
</li>

                    </ul>
                </div>

                {/* Follow Us */}
                <div>
                    <div>
                        <h3 className="font-semibold mb-2">
                            {footerContent.headings.app[selectedLang]}
                        </h3>
                        <ul className="list-disc ml-4">
                            <li><a href={footerContent.links.appLink.href} className="hover:underline">
                                {footerContent.links.appLink.label[selectedLang]}
                            </a>
                            </li>
                        </ul>
                    </div>
                    <div className="mt-2">
                        <h3 className="font-semibold mb-2">
                            {footerContent.headings.followUs[selectedLang]}
                        </h3>
                        <div className="flex gap-3">
                            <button onClick={handleOpenInstagram} className="bg-white rounded-full p-1 hover:opacity-80 transition">
                                <FaInstagram className="text-[#FFA500] h-5 w-5" />
                            </button>
                            <button onClick={handleOpenYouTube} className="bg-white rounded-full p-1 hover:opacity-80 transition">
                                <GrYoutube className="text-[#FFA500] h-5 w-5" />
                            </button>
                            <button onClick={handleOpenFacebook} className="bg-white rounded-full p-1 hover:opacity-80 transition">
                                <TiSocialFacebook className="text-[#FFA500] h-5 w-5" />
                            </button>
                            <button onClick={handleOpenTwitter} className="bg-white rounded-full p-1 hover:opacity-80 transition">
                                <FaXTwitter className="text-[#FFA500] h-5 w-5" />
                            </button>
                        </div>
                    </div>
                </div>

                <div className="text-center no-dark-bg">
                    <div className="flex flex-col justify-center">
                        <div className="flex items-center gap-1">
                            <span className="font-semibold">{footerContent?.headings.visitorsCount[selectedLang]}</span>
                            <div className="flex gap-0.5">
                                {totalDigits.map((digit, i) => (
                                    <span key={`total-digit-${i}-${digit}`} className="text-white text-[12px]">
                                        {digit}
                                    </span>
                                ))}
                            </div>

                        </div>

                        <div className="flex items-center gap-1">
                            <span className="font-semibold">{footerContent?.headings.dailyVisitors[selectedLang]}</span>
                            <div className="flex gap-0.5">
                                {todayDigits.map((digit, i) => (
                                    <span key={`today-digit-${i}-${digit}`} className="text-white text-[12px]">{digit}</span>
                                ))}
                            </div>
                        </div>

                        <div className="flex items-center gap-1">
                            <span className="font-semibold">{footerContent.headings.latestMonth[selectedLang]}</span>
                            <span className="text-white flex items-center justify-center text-[12px] rounded">{displayLatestMonth}</span>
                        </div>

                        <div className="flex items-center gap-1">
                            <span className="font-semibold">{footerContent.headings.latestReviewDate[selectedLang]}</span>
                            <span className="text-white flex items-center justify-center text-[12px] rounded">{displayLatestReviewDate}</span>
                        </div>


                    </div>

                </div>

            </div>



            {/* COPYRIGHT */}
            <div className="mt-3 text-center text-[10px]">
                {selectedLang === 'English'
                    ? "©️ This is the official website of Directorate of Archaeology & Museums, Department of Cultural Affairs, Government of Maharashtra, India. All Rights Reserved."
                    : "©️ हे महाराष्ट्र राज्य सांस्कृतिक कार्य विभागाच्या पुरातत्व व वस्तूसंग्रहालये संचालनालय यांचे अधिकृत संकेतस्थळ आहे. सर्व हक्क सुरक्षित."
                }
            </div>

        </footer>
    );
};

export default Footer;
